import { createValidation } from '../../../utils/validation';

export const createTrainingValidation = (config) => {
  return createValidation(config);
};

